import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { Currency } from "./currencies";
import { RateSource } from "./rate-source";

/**
 * Snapshot of a frozen conversion attached to a {@link Money}: the original
 * pre-conversion amount plus optional provenance (which rate source, as of
 * when). Displays and refunds reconvert from this snapshot, never from a live
 * rate. Plain float major units — same representation as `Money.amount`.
 */
export const struckSnapshotSchema_ = z.object({
  amount: z.number(),
  // enumName lets this schema be extracted for congodb DDL when embedded in a
  // persisted collection (e.g. FulfillmentGroup's selectedShippingRate.struck).
  currency: createEnum(Currency, { enumName: "Currency" }),
  source: createEnum(RateSource, { enumName: "RateSource" }).optional(),
  asOf: z.number().int().optional(),
});

export const StruckSnapshotSchema: z.ZodType<StruckSnapshot> =
  struckSnapshotSchema_;
export interface StruckSnapshot extends z.infer<typeof struckSnapshotSchema_> {}
